const appConfig = {
    IDLE_TIMEOUT_MINUTES: 15,
};

export default appConfig;
